import { useApiMutation } from '../../../shared/useApi.js';
import { api } from '../../../shared/api.js';

export function useSimulate() {
  return useApiMutation({
    mutationFn: (body) => api.post('/pricing/simulate', body).then((r) => r.data),
    errorToast: true
  });
}
